import { LinkOutlined, StopOutlined, SyncOutlined } from "@ant-design/icons";
import { Pagination } from "@mui/material";
import { Button, Drawer, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";
import Share from "../../assets/icons/share.svg";
import Download from "../../assets/icons/Download.svg";
import certificateImg from "../../assets/images/certificate.png";
import LoaderOverlay from "../../reusableComponents/LoaderOverlay/Index";
import NoData from "../../reusableComponents/Nodata";
import {
  generateCertificates,
  getCertificates,
} from "../../utils/apis/userApi";
import "./style.scss";
function Certificates() {
  const { idToken } = useSelector((state) => state.auth);
  const [certificateData, setCertificateData] = useState({
    results: [],
    count: 0,
  });
  const [params, setParams] = useState({ page: 1, page_size: 9 });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCertificates();
  }, [params]);

  const fetchCertificates = async () => {
    setIsLoading(true);
    try {
      const response = await getCertificates(idToken, params);
      setCertificateData(response?.data || { results: [], count: 0 });
    } catch (error) {
      console.error("Error fetching certificates:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenModal = (certificate) => {
    setSelectedCertificate(certificate);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCertificate(null);
  };

  return (
    <div className="certificates">
      {isLoading && <LoaderOverlay />}
      {!isLoading && certificateData?.results?.length === 0 && (
        <NoData msg="No certificates found" />
      )}
      <div className="certificate-box-wrapper">
        {certificateData?.results?.map((certificate) => (
          <CertificateBox
            key={certificate?.id || certificate?.file}
            data={certificate}
            onClick={() => handleOpenModal(certificate)}
          />
        ))}
      </div>
      {Math.ceil(certificateData?.count / params.page_size) > 1 && (
        <div className="pagination-container">
          <Pagination
            count={Math.ceil(certificateData?.count / params.page_size)}
            page={params.page}
            onChange={(e, page) =>
              setParams((prevParams) => ({ ...prevParams, page }))
            }
            size="small"
            showFirstButton
            showLastButton
            shape="rounded"
            className="pagination"
          />
        </div>
      )}
      <ShareCertificateModal
        data={selectedCertificate}
        isModalOpen={isModalOpen}
        handleClose={handleCloseModal}
        fetchCertificates={fetchCertificates}
      />
    </div>
  );
}

export default Certificates;

const CertificateBox = ({ data, onClick }) => {
  if (!data) return null;
  return (
    <div className="certificate-box">
      <img src={data?.file || certificateImg} alt="Certificate" />
      <div className="bottom_btns">
        <a
          href={`https://fundedaward.com/futures` || "#"}
          target="_blank"
          rel="noopener noreferrer"
          className="gradient-border-btn"
          style={{ textWrap: "nowrap" }}
        >
          Frame certificate
        </a>
        <span>
          <a href={data?.file || "#"} target="_blank" rel="noopener noreferrer">
            <img src={Download} alt="Download" />
          </a>
        </span>
        <span onClick={onClick}>
          <img src={Share} alt="share" />
        </span>
      </div>
    </div>
  );
};

const ShareCertificateModal = ({
  data,
  isModalOpen,
  handleClose,
  fetchCertificates,
}) => {
  const [copied, setCopied] = useState(false);
  const [isPublic, setIsPublic] = useState(data?.is_public || false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const certificateUrl = `${window.location.origin}/share-certificates/${data?.id}`;
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    data && setIsPublic(data?.is_public);
  }, [data]);

  const handleCopy = () => {
    navigator.clipboard.writeText(certificateUrl);
    setCopied(true);
    message.success("Link copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  const toggleCertificate = async () => {
    try {
      setLoading(true);
      const response = await generateCertificates(data?.id, "put", {
        public: !isPublic,
      });
      setIsPublic(response?.data?.public || !isPublic);
      message.success(
        response?.data?.public
          ? "Link generated successfully!"
          : "Link disabled."
      );
      fetchCertificates();
    } catch (error) {
      message.error("Failed to update link status.");
    } finally {
      setLoading(false);
    }
  };

  const content = (
    <>
      {isPublic ? (
        <>
          <p>Link generated. Copy and share it!</p>
          <p>You can disable the link anytime.</p>
          <Button
            type="primary"
            danger
            icon={<StopOutlined />}
            loading={loading}
            onClick={toggleCertificate}
          >
            Disable Link
          </Button>
        </>
      ) : (
        <div className="generate-link-container">
          <p>Link not generated. Please generate a link to share.</p>
          <Button
            type="primary"
            icon={<SyncOutlined />}
            loading={loading}
            onClick={toggleCertificate}
          >
            Generate Link
          </Button>
        </div>
      )}

      {isPublic && (
        <>
          <div className="share-options">
            <FacebookShareButton url={certificateUrl}>
              <FacebookIcon size={50} round />
            </FacebookShareButton>
            <TwitterShareButton url={certificateUrl}>
              <XIcon size={50} round />
            </TwitterShareButton>
            <WhatsappShareButton url={certificateUrl}>
              <WhatsappIcon size={50} round />
            </WhatsappShareButton>
            <TelegramShareButton url={certificateUrl}>
              <TelegramIcon size={50} round />
            </TelegramShareButton>
            <EmailShareButton url={certificateUrl}>
              <EmailIcon size={50} round />
            </EmailShareButton>
          </div>

          <div className="share-link-container">
            <input
              type="text"
              value={certificateUrl}
              readOnly
              className="share-link"
            />
            <button onClick={handleCopy} className="copy-btn">
              {copied ? (
                "Copied!"
              ) : (
                <>
                  <LinkOutlined /> Copy Link
                </>
              )}
            </button>
          </div>
        </>
      )}
    </>
  );

  return isMobile ? (
    <Drawer
      title="Share Certificate"
      placement="bottom"
      onClose={handleClose}
      open={isModalOpen}
      className="share-certificates-modal"
    >
      {content}
    </Drawer>
  ) : (
    <Modal
      title="Share Certificate"
      open={isModalOpen}
      onCancel={handleClose}
      footer={null}
      className="share-certificates-modal"
    >
      {content}
    </Modal>
  );
};
